import { BaseInputModel } from "./BaseInputModel"

export abstract class BaseDeleteInputModel extends BaseInputModel {
  get body(): Record<string, unknown> {
    return {}
  }
}
